import { z } from 'zod';
export var TestCompletedSchema = z.object({
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    contact_number: z.string().nullable(),
    snr_result: z.number().nullable(),
    hearing_category: z.string().nullable(),
    user_selected_volume: z.number().nullable(),
    source: z.string(),
});
